module.exports = __webpack_public_path__ + "img/x.c9319cb2.svg";